import { LoginFormField } from "../types/login-page.types";
import { Validators } from "@angular/forms";

export const loginFormFields: Array<LoginFormField> = [
  {
    fieldName: 'username',
    label: 'Никнейм',
    validators: [ Validators.required ],
    type: 'email',
    placeholder: 'Введите ваш никнейм'
  },
  {
    fieldName: 'password',
    label: 'Пароль',
    validators: [ Validators.required ],
    type: 'password',
    placeholder: 'Введите пароль'
  }
]
